import React from 'react';
import { func } from 'prop-types';

const CantCompleteEditDilogContent = ({ onClose }) => {
  const _handleGotItCliick = () => {
    onClose()
  };
  return (
    <div className="de__unsaved--body">
      <span>
        Some of the target’s data points are unavailable in the currently
        selected study. To edit target, change the study selector to match your
        target’s study.
      </span>
      <div className="de__unsaved--actions">
        <button
          type="button"
          onClick={_handleGotItCliick}
          className="de--btn de--btn__primary"
        >
          Got It
        </button>
      </div>
    </div>
  );
};

CantCompleteEditDilogContent.propTypes = {
  onClose: func
}

export default CantCompleteEditDilogContent;
